import {
  PendingPage,
  type PendingPageCode,
} from '@resurs-internal/deposits-app-components';
import { useContext } from 'react';
import { useLocation, useOutletContext } from 'react-router';

import { type ApplicationHandlerProps } from '@/components';
import { CountryContext } from '@/contexts';
import { sendGTMApplicationStatus } from '@/helpers';
import { type GTMStatus } from '@/models';

export const PendingView = () => {
  const location = useLocation();
  const code: PendingPageCode =
    location.state?.code && location.state?.code === '409'
      ? location.state?.code
      : '200';

  const { country } = useContext(CountryContext);
  const { applicationId, product } =
    useOutletContext() as ApplicationHandlerProps;

  const handleGTMStatus = (
    applicationId: string,
    productVariant: string,
    stepName: string,
    status: string,
  ) => {
    sendGTMApplicationStatus({
      applicationId,
      country,
      productVariant,
      status: status as GTMStatus,
      stepName,
    });
  };

  return (
    <PendingPage
      applicationId={applicationId}
      code={code}
      country={country}
      product={product}
      sendGTMApplicationStatus={handleGTMStatus}
    />
  );
};
